export const sanitizer = (txt: string) => txt.replace(/(.{4})/g, '$1 ').replace(/(\s)/g, '');
export const encodeToBase64 = (value: string) => btoa(unescape(encodeURIComponent(value)));
export const encodeToBase64Url = (value: string) => {
  const base64 = encodeToBase64(value);
  return encodeURIComponent(base64);
};
